<template>
  <div>
    <van-popup v-model:show="showPopup" position="bottom" @close="emit('close')">
      <div class="deposito-popup">
        <div class="deposito-popup-header">
          <div class="chxy-row-bt header-view">
            <div class="header-left" @click="onClickLeft">
              <van-icon name="arrow-left" class="arrow-icon" />
            </div>
            <div class="header-center">{{ $t('deposito-index.title') }}</div>
            <div class="header-right">
              <div class="support-message">
                <div class="support-container mr-20px" @click="toMessage()">
                  <SvgIcon
                    name="deposito-menu_customer_service"
                    fill="var(--deposito-icon-menu_customer_service)"
                    :size="20"
                  />
                </div>
                <div class="support-container mr-5px" @click="handleDepositoRecordPopupOpen()">
                  <SvgIcon
                    name="deposito-menu_historical_records"
                    fill="var(--deposito-icon-menu_historical_records)"
                    :size="20"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="pagamento-container">
            <div class="chxy-row-bt money-view">
              <div>
                <img
                  v-if="isBrazil"
                  :src="getImageUrlWithCDN_TEST('/home/icon-currency.png', 'local')"
                  class="pt-icon"
                />
                <img
                  v-else
                  :src="getImageUrlWithCDN_TEST('/home/pt-mx.png', 'local')"
                  alt="logo"
                  class="pt-icon"
                />
              </div>
              <span class="money">
                {{
                  isRefreshing
                    ? 'loading'
                    : formatNumberWithComma(balance) || formatNumberWithComma(0)
                }}
              </span>
              <div
                ref="refreshIconRef"
                :class="['refresh-icon', { rotating: isRefreshing }]"
                @click="handleRefresh"
              >
                <SvgIcon
                  name="public-info_balance_refresh_style-1"
                  fill="var(--home-header-icon-info_balance_refresh_style-1)"
                  :size="16"
                />
              </div>
            </div>
            <div v-if="!isMX" class="pagamento-row">
              <span class="saldo-label">Saldo</span>
              <div class="pagamento">Método de Pagamento</div>
            </div>
          </div>
        </div>
        <div class="fix-h"></div>
        <div class="h-24px"></div>

        <van-tabs
          v-model:active="tabsActive"
          :show-header="false"
          shrink
          line-width="100"
          @click-tab="handleTabClick"
        >
          <van-tab>
            <template #title>
              <div class="tabs-title-slot">
                <span class="title">{{ $t('deposito-index.depositoOnline') }}</span>
              </div>
            </template>
            <div class="phone-online-container">
              <div v-if="!isMX">
                <div class="group-view-container">
                  <div
                    v-for="(value, index) in grupoTypeTabs"
                    :key="index"
                    class="chxy-row-ac grupo-view"
                  >
                    <img class="grupo-img" :src="getImageUrlWithCDN_TEST('/deposito/pix.png')" />
                    <span class="grupo-text">{{ value }}</span>
                  </div>
                </div>
                <div class="line2"></div>
                <div class="h-10"></div>
              </div>
              <div class="deposito">{{ $t('deposito-index.deposito') }}</div>
              <div class="h-10"></div>
              <div>
                <van-field
                  v-model="moneyValue"
                  class="field-border-radius"
                  type="number"
                  :class="{
                    error: inputMoneyType == 'error',
                    success: inputMoneyType == 'success',
                    'with-tip': showAmountLimitTip,
                  }"
                  :label="currencySymbol"
                  :placeholder="onlineAmountPlaceholder"
                  :clearable="true"
                  @blur="blurFun"
                  @clear="clearFun"
                  @update:model-value="handleUpdateFun"
                />
                <div v-if="showAmountErrorTip" class="money-error-tip">
                  <img
                    class="error-icon"
                    :src="getImageUrlWithCDN_TEST('/login/danger.png')"
                    alt=""
                  />
                  <span>
                    {{ $t('deposito-index.limit') }} {{ currencySymbol
                    }}{{ formatNumberWithThousandsSeparator(11) }}~{{
                      formatNumberWithThousandsSeparator(100000)
                    }}
                  </span>
                </div>
                <div v-if="showAmountLimitTip" class="money-limit-tip">
                  <span>{{ $t('deposito-index.vocePodeReceberAte') }}</span>
                  <span class="tip-num">{{ formatNumberWithComma(tipReceiveTotal) }}</span>
                  <span class="textColorGreen">{{ $t('deposito-index.lembreSeDeColetar') }}</span>
                  <span>,{{ $t('deposito-index.bonusDo') }}</span>
                  <span>{{ $t('deposito-index.evento') }}</span>
                  <span class="tip-num tip-num-bonus">
                    +{{ formatNumberWithComma(moneyBonus || 0) }}
                  </span>
                </div>
              </div>
              <div class="h-10"></div>
              <div v-if="hadFirstDeposito" class="dep-group-container">
                <div v-for="(item, index) in rechargeChannel.quick_amounts" :key="index">
                  <div
                    class="chxy-column-c-c"
                    :class="checkMoneyIndex == index ? 'dep-item-check' : 'dep-item'"
                    @click="checkMoney(index, item)"
                  >
                    <div class="dep-t">{{ formatNumberWithThousandsSeparator(item || 0) }}</div>
                    <div class="chxy-row-c-c dep-b">
                      +{{ formatNumberWithComma(rechargeChannel?.quick_reward[index] || 0) }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="dep-group-container">
                <div v-for="(item, index) in rechargeChannel.quick_amounts" :key="index">
                  <div
                    class="chxy-column-c-c"
                    :class="checkMoneyIndex == index ? 'dep-item-check' : 'dep-item'"
                    @click="checkMoney(index, item)"
                  >
                    <div class="dep-t2">{{ formatNumberWithThousandsSeparator(item || 0) }}</div>
                  </div>
                </div>
              </div>
              <div class="h-10"></div>
            </div>
          </van-tab>
        </van-tabs>

        <!-- 存款优惠活动 -->
        <div>
          <div class="deposit-container">
            <div class="h-10"></div>
            <div class="chxy-row-bt">
              <div class="chxy-row-ac">
                <img
                  :src="getImageUrlWithCDN_TEST('/deposito/Oferta.png', 'local')"
                  class="gife-icon"
                />
                <span class="oferta">{{ $t('deposito-index.depositOffer') }}</span>
              </div>
              <div class="chxy-row-ac lt-view">
                <div class="lt-icon-container">
                  <img
                    :src="getImageUrlWithCDN_TEST('/deposito/lt.png', 'local')"
                    class="lt-icon"
                  />
                  <span class="lt-text">LT</span>
                </div>
                <van-count-down ref="countDown" millisecond :time="downTime" format="HH:mm:ss:S" />
              </div>
            </div>
            <div class="deposit-desc">
              {{ $t('deposito-index.activityDesc') }}
            </div>
            <div v-for="(item, index) in rechargeChannel.quick_amounts" :key="index">
              <div v-if="index < moreShow" class="primeiro chxy-row-bt">
                <div class="chxy-row-ac">
                  <div class="primeiro-1"></div>
                  <img
                    class="primeiro-2-img"
                    :src="getImageUrlWithCDN_TEST('/deposito/Bonus.png', 'local')"
                  />
                  <span class="primeiro-3-text">{{ $t('deposito-index.bonus') }}</span>
                  <span class="primeiro-4-text">
                    {{ formatNumberWithComma(rechargeChannel?.quick_reward[index] || 0) }}
                  </span>
                </div>
                <div class="chxy-row-ac primeiro-5-wrap">
                  <div class="primeiro-5-text">
                    <span class="label">{{ $t('deposito-index.primeiroDeposito') }}</span>
                    <span class="value">≥{{ formatNumberWithThousandsSeparator(item || 0) }}</span>
                  </div>
                  <img
                    v-if="isCurrentLevel(item, index)"
                    class="primeiro-6-img"
                    :src="getImageUrlWithCDN_TEST('/deposito/gou.png', 'local')"
                  />
                  <div v-else class="primeiro-6-img" />
                </div>
              </div>
            </div>
          </div>
          <!-- 更多收缩 -->
          <div class="chxy-row-c-c expand-container" @click="handleMoreChange">
            <div class="expand-text">{{ moneyListMore ? 'Passar' : 'Expandir' }}</div>
            <van-icon v-show="!moneyListMore" name="arrow-down" class="expand-icon" />
            <van-icon v-show="moneyListMore" name="arrow-up" class="expand-icon" />
          </div>
        </div>
        <div
          class="deposit-now-button"
          :class="{ disabled: isDepositButtonDisabled }"
          @click="!isDepositButtonDisabled && toDepositeDebounce()"
        >
          {{ $t('deposito-index.depositNow') }}
        </div>
      </div>

      <DepositoPay ref="depositoPayRef" :pay-info="payInfo" @close="handleDepositoPayClose" />
    </van-popup>

    <DepositoRecordPopup ref="DepositoRecordPopupRef" />

    <van-loading v-if="isLoading" vertical class="loading-overlay"></van-loading>
  </div>
</template>

<script setup>
import { debounce } from '@/utils/debounce'
import { userBalanceApi } from '@/api/deposito'
import { langEnums, locale, isBrazil, currencySymbol, getCurrencySymbol } from '@/utils/i18n'
import { STORAGE_USER_INFO_KEY } from '@/stores/mutation-type'
import { rechargeIndex, rechargeStartApi } from '@/api/deposito'
import { useEventBus } from '@vueuse/core'
import { formatNumberWithComma, formatNumberWithThousandsSeparator } from '@/utils/format.js'

const balanceEventBus = useEventBus('refresh-balance')

const router = useRouter()
const { t } = useI18n()
const downTime = ref('')
const countDown = ref(null)
const isLoading = ref(false)
const balance = ref(false)

const isMX = computed(() => locale.value === langEnums.ES_MX)

const grupoTypeTabs = ref([])
const Grupo = ref([])

const tabsActive = ref(0)
const isRefreshing = ref(false) // 刷新状态
const moneyValue = ref() // 充值金额
const moneyBonus = ref() // 奖金
const moneyBonusAll = ref() // 总值（充值金额 + 奖金）
const moneyBonusFlag = ref(false) // 金币赠送活动  标志
const isOpenFirstDeposito = ref(false)
const hadFirstDeposito = ref(false) // 金币赠送活动 首充值是否有
const moneyListMore = ref(false) // 金币赠送list 开关
const moreShow = ref(3)
const checkMoneyIndex = ref(-1)

const activeGrupoTypeTabId = ref(0)

const DepositoRecordPopupRef = ref(null)
const handleDepositoRecordPopupOpen = () => {
  nextTick(() => {
    DepositoRecordPopupRef.value.open()
  })
}
const handleGrupoTypeTabChange = (index) => {
  // console.log('activeGrupoTypeTabId.value -----', activeGrupoTypeTabId.value)
  activeGrupoTypeTabId.value = index
}

const usdtTypeList = ref([{ id: 1, name: 'TRC20-USDT', value: '', icon: 'usdt-icon' }])
const usdtTypeChecked = reactive({
  id: 1,
  name: 'TRC20-USDT',
  value: '',
})
const handleUsdtTypeChange = (e) => {
  for (const key in usdtTypeChecked) {
    usdtTypeChecked[key] = e[key]
  }
}

const handleTabClick = (e) => {
  // if (tabsActive.value === 1) {
  //   showToast('')
  // }
}

/**
 * 充值类型为 Criptomoeda 货币时
 */
const criptomoedaLabelEnum = reactive({
  USDT: 'U',
  Dollar: 'R$',
})
const criptomoedaTypeEnum = reactive({
  USDT: 'USDT',
  Dollar: 'Dollar',
})
const criptomoedaTypeList = reactive([
  {
    label: criptomoedaLabelEnum.USDT,
    min_amount: '5',
    max_amount: '1.000.000',
    type: criptomoedaTypeEnum.USDT,
  },
  {
    label: criptomoedaLabelEnum.Dollar,
    min_amount: '28',
    max_amount: '5.570.361',
    type: criptomoedaTypeEnum.Dollar,
  },
])
const criptomoedaTypeCurrent = reactive({
  label: 'U',
  min_amount: '5',
  max_amount: '1.000.000',
  type: 'USDT',
})
const handleCriptomoedaTypeCurrentSwitch = () => {
  const list = toRaw(criptomoedaTypeList)
  switch (criptomoedaTypeCurrent.type) {
    case criptomoedaTypeEnum.USDT:
      handleCriptomoedaTypeCurrentChange(criptomoedaTypeList[1])
      break
    case criptomoedaTypeEnum.Dollar:
      handleCriptomoedaTypeCurrentChange(criptomoedaTypeList[0])
      break
  }
}
const handleCriptomoedaTypeCurrentChange = (object) => {
  for (const key in criptomoedaTypeCurrent) {
    criptomoedaTypeCurrent[key] = object[key]
  }
}

const payInfo = ref({})

const toMessage = () => {
  showPopup.value = false
  router.push({
    name: 'Messages',
    query: {
      type: 1,
    },
  })
}

// 金额 < 11 或 > 100000 时禁用按钮
const isDepositButtonDisabled = computed(() => {
  const amount = Number(moneyValue.value)
  if (moneyValue.value === '' || Number.isNaN(amount)) return true
  return amount < 11 || amount > 100000
})
// 金额 < 11 或 > 100000 时显示红色限额提示
const showAmountErrorTip = computed(() => {
  if (moneyValue.value === '' || moneyValue.value == null) return false
  const amount = Number(moneyValue.value)
  if (Number.isNaN(amount)) return false
  return amount < 11 || amount > 100000
})

// 金额在 11~100000 时显示底部到账提示
const showAmountLimitTip = computed(() => {
  if (moneyValue.value === '' || moneyValue.value == null) return false
  const amount = Number(moneyValue.value)
  if (Number.isNaN(amount)) return false
  return amount >= 11 && amount <= 100000
})

// 可到账总额 = 当前输入金额 + 活动奖励
const tipReceiveTotal = computed(() => {
  const amount = Number(moneyValue.value) || 0
  const bonus = Number(moneyBonus.value) || 0
  return amount + bonus
})
// const toRegistros = () => {
//   showPopup.value = false
//   router.push({
//     name: 'Registros',
//     query: {
//       type: 1,
//     },
//   })
// }

const checkMoney = (index, item) => {
  checkMoneyIndex.value = index
  moneyValue.value = item
  currentLevelIndex.value = index
  moneyBonus.value = Number(rechargeChannel.value?.quick_reward?.[index] || 0)
  moneyBonusFlag.value = moneyBonus.value > 0
}
// 处理刷新点击事件
const handleRefresh = async () => {
  if (isRefreshing.value) return // 如果正在刷新，则不处理重复点击

  const { data } = await userBalanceApi()
  balance.value = data.balance

  isRefreshing.value = true

  // 模拟刷新过程，1秒后结束
  setTimeout(() => {
    isRefreshing.value = false
  }, 1000)
}

const handleDepositoPayClose = () => {
  handleRefresh()
}

const handleMoreChange = () => {
  moneyListMore.value = !moneyListMore.value
  moreShow.value = moneyListMore.value ? 99 : 3
}

const clearFun = (even) => {
  console.log('even:', even)
}

// 输入框失去焦点 触发接口 充值预览api/transfer/rechargePreview（最新版本不需要）
const blurFun = (even) => {
  console.log('blurFun even:', even)
  // if (moneyValue.value > 0) {
  //   // 调用接口 查询赠送的金额 再赋值给 moneyBonus
  //   moneyBonusFlag.value = true
  //   moneyBonusAll.value = 99
  //   moneyBonus.value = 50
  //   checkMoneyIndex.value = 999
  // } else {
  //   moneyBonusAll.value = 0
  //   moneyBonus.value = 0
  //   moneyBonusFlag.value = false
  // }
}

const inputMoneyType = ref('')
watch(moneyValue, (val) => {
  const min = Number(rechargeChannel.value.min_amount)
  const max = Number(rechargeChannel.value.max_amount)
  if (val == '' || Number(val) < min || Number(val) > max) {
    inputMoneyType.value = 'error'
  } else {
    inputMoneyType.value = 'success'
  }
})

// 当前匹配的档位索引
const currentLevelIndex = ref(-1)

// 监听输入框输入事件
const handleUpdateFun = (newVal) => {
  // 重置选中状态
  checkMoneyIndex.value = -1
  // 重置当前档位索引
  currentLevelIndex.value = -1

  if (
    newVal > 0 &&
    rechargeChannel.value.has_activity == 1 &&
    rechargeChannel.value.quick_reward?.length > 0 &&
    rechargeChannel.value.quick_amounts?.length > 0
  ) {
    let applicableBonus = 0
    let maxApplicableAmount = 0
    let matchedIndex = -1

    // 找到小于等于输入金额的最大档位
    for (let i = 0; i < rechargeChannel.value.quick_amounts.length; i++) {
      const amount = Number(rechargeChannel.value.quick_amounts[i])
      if (newVal >= amount && amount > maxApplicableAmount) {
        maxApplicableAmount = amount
        applicableBonus = Number(rechargeChannel.value.quick_reward[i])
        matchedIndex = i
      }
    }

    // 更新当前档位索引
    currentLevelIndex.value = matchedIndex
    moneyBonus.value = applicableBonus
    moneyValue.value = newVal
    moneyBonusFlag.value = applicableBonus > 0
  } else {
    moneyBonusFlag.value = false
    moneyBonus.value = 0
  }
}

// 判断当前档位是否应该显示勾选图标
const isCurrentLevel = (item, index) => {
  return currentLevelIndex.value === index
}
const showPopup = ref(false)

// 定义emit事件
const emit = defineEmits(['refresh', 'close'])

const onClickLeft = () => {
  balanceEventBus.emit()
  emit('close')
  showPopup.value = false
}

const depositoPayRef = ref()
const showPopupPay = ref(false)

const toDeposite = async () => {
  if (
    moneyValue.value >= +rechargeChannel.value.min_amount &&
    moneyValue.value <= +rechargeChannel.value.max_amount
  ) {
    isLoading.value = true
    const sendData = {
      amount: Number(moneyValue.value),
    }
    try {
      const { data, code } = await rechargeStartApi(sendData)
      if (code == 1) {
        payInfo.value = data
        depositoPayRef.value?.openPopupDepositPay()
        checkMoneyIndex.value = -1
        moneyValue.value = ''
      }
    } finally {
      isLoading.value = false
    }
  } else {
    showToast({
      message:
        'Insira o valor coreto, limite (' +
        rechargeChannel.value.min_amount +
        '~' +
        rechargeChannel.value.max_amount +
        ')',
      wordBreak: 'break-word',
    })
  }
}
const toDepositeDebounce = debounce(toDeposite, 1000, true)

const rechargeChannel = ref({})
const userInfo = ref({})

const rechargeChannelMinAmount = computed(() => {
  return formatNumberWithComma(rechargeChannel.value.min_amount)
})

const rechargeChannelMaxAmount = computed(() => {
  return formatNumberWithComma(rechargeChannel.value.max_amount)
})
const onlineAmountPlaceholder = computed(() =>
  t('deposito-index.amountPlaceholder', {
    min: rechargeChannelMinAmount.value,
    max: rechargeChannelMaxAmount.value,
  })
)

async function initData() {
  const { data } = await rechargeIndex()
  rechargeChannel.value = data.recharge_channel
  // rechargeChannel.value.quick_amounts 逗号拼接的string，转成数组
  rechargeChannel.value.quick_amounts = rechargeChannel.value.quick_amounts.split(',')
  rechargeChannel.value.quick_reward = rechargeChannel.value.quick_reward.split(',')
  userInfo.value = data.user_info
  hadFirstDeposito.value = data.recharge_channel.has_activity
  downTime.value = Number(rechargeChannel.value.countdown || 0) * 1000 // 30 * 60 * 60 * 1000
  if (countDown.value) {
    countDown.value.reset()
  }
  try {
    // Grupo 默认就一个方式 后面需求调整了再同步调整
    if (data.recharge_channel.display_title && data.recharge_channel.display_title.length > 0) {
      Grupo.value = data.recharge_channel.display_title[0]
    } else {
      Grupo.value = 'PIX'
    }
    if (data?.recharge_channel?.display_type && data?.recharge_channel?.display_type.length > 0) {
      grupoTypeTabs.value = data?.recharge_channel?.display_type
    }
  } catch (error) {
    //
  }
}

// 提供给父组件调用的方法
const openPopupDeposit = () => {
  showPopup.value = true
  checkMoneyIndex.value = -1
  moneyValue.value = ''
  initData()
  handleRefresh()
}
// 暴露给父组件的方法和状态
defineExpose({
  openPopupDeposit,
})
</script>

<style lang="scss" scoped>
::v-deep(.van-overlay) {
  z-index: 1999 !important;
}
:deep(.van-tabs__nav) {
  background: transparent;
}
.deposito-popup {
  background-color: var(--deposito-view-bg);
  height: calc(100vh - 45px);
  height: calc(100dvh - 45px);
  width: 100vw;
  border-radius: 10px 10px 0 0;
  overflow-y: scroll;
  --van-field-label-width: 20px;
  :deep(.van-field) {
    height: 37.5px !important;
    --van-field-label-color: var(--deposito-card-title) !important;
  }
  .van-cell {
    padding: 5px 10px;
  }

  .deposito-popup-header {
    position: fixed;
    z-index: 1;
    .header-view {
      position: relative;
      width: 100vw;
      height: 46px;
      width: 100vw;
      border-radius: 10px 10px 0 0;
      background-color: var(--deposito-view-bg);

      .header-left {
        position: absolute;
        // margin-left: 10px;
        width: 40px;
        height: 50px;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .arrow-icon {
          color: var(--deposito-arrow-icon);
        }
      }
      .header-center {
        width: 100%;
        font-size: 16px;
        color: var(--deposito-card-title);
        text-align: center;
      }
      .header-right {
        position: absolute;
        top: 0;
        right: 0;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        .support-message {
          display: flex;
          padding: 10px;
          .dep-one {
            width: 16px;
            height: 18px;
          }

          .dep-two {
            width: 17px;
            height: 18px;
          }
        }
      }
    }
  }
}

.tabs-title-slot {
  position: relative;
  display: flex;
  align-items: center;

  .icon-box {
    margin-right: 6px;
    width: 16px;
    height: 16px;

    .icon {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    height: 16px;
  }
  .interest-rate-tag {
    position: absolute;
    right: 2px;
    top: -10px;
  }
}

.deposito-type {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 15px 0 10px;
  margin-bottom: 10px;
  border-top: 1px solid var(--deposito-card-border-bottom);
  border-bottom: 1px solid var(--deposito-card-border-bottom);

  .but-item-check {
    position: relative;
    padding: 0 4px;
    width: 170px;
    height: 36px;
    border-radius: 5px;
    // border: 1px solid var(--deposito-tag-border);
    border: 1px solid #cecece;

    &.checked {
      border-color: var(--deposito-tag-active-border);
      .text {
        color: var(--deposito-tag-active-text);
      }
    }
    &.tag {
      .interest-rate-tag {
        position: absolute;
        right: -10px;
        top: -8px;
      }
    }

    .type-icon {
      width: 28px;
      height: 28px;
    }
    .text {
      width: calc(100% - 28px);
      font-family: Roboto, Roboto;
      font-size: 13px;
      color: var(--deposito-tag-text);
      text-align: center;
    }
  }
}

.field-type-container {
  &.criptomoeda {
    display: grid;
    grid-template-columns: auto 36px;
    grid-gap: 10px;
    margin-top: 10px;

    .switch-icon-box {
      width: 36px;
      height: 36px;
      border: 1px solid var(--deposito-card-border);
      border-radius: 8px;

      .icon {
        width: 18px;
        height: 18px;
      }
    }
  }
}

.fix-h {
  height: 66px;
}
.m10 {
  margin: 0 10px;
}

.phone-online-container {
  // padding-top: 15px;
  margin: 0 10px;
  // border-top: 1px solid var(--deposito-card-border-bottom);

  .group-view-container {
    // margin: 0 10px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-top: 30px;

    .grupo-view {
      height: 37px;
      padding: 4px;
      border-radius: 4px;
      border: 1px solid var(--deposito-tag-border);

      .grupo-img {
        width: 27px;
        height: 27px;
      }

      .grupo-text {
        width: calc(100% - 37px);
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 12px;
        color: var(--deposito-tag-text);
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }
  }
}

.criptomoeda-container {
  padding: 0 10px 10px;

  .ratio-valor-container {
    padding: 5px 0 0;
    line-height: 1;

    .title {
      font-size: 12px;
      color: var(--deposito-card-label);
    }
    .value-container {
      font-size: 12px;
      color: var(--deposito-card-value);

      .ratio-box {
        .value {
          margin-right: 6px;
        }
        .refresh-icon {
          width: 11px;
          height: 11px;
        }
      }

      .valor-box {
        font-weight: 700;
        color: var(--deposito-card-value__highlight);
      }
    }
  }
}

.grupo-view {
  position: relative;
  padding: 0 4px;
  width: 170px;
  height: 36px;
  border-radius: 5px;
  border: 1px solid var(--deposito-tag-border);

  &.active {
    border-color: var(--deposito-tag-active-border);

    .grupo-text {
      color: var(--deposito-tag-active-text);
    }
    .select-icon {
      opacity: 1;
    }
  }

  .grupo-img {
    width: 27px;
    height: 27px;
  }
  .grupo-text {
    width: calc(100% - 37px);
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 13px;
    color: var(--deposito-tag-text);
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
  .select-icon {
    position: absolute;
    right: -1px;
    bottom: 2px;
    width: 18px;
    height: 11px;
    opacity: 0;
  }
}

.field-border-radius {
  border-radius: 7px;
  font-size: 17px;
  font-weight: 700;
  :deep(.van-field__label) {
    width: fit-content;
    font-size: 12px;
  }
  :deep(.van-field__control) {
    &::placeholder {
      font-size: 11px;
    }
  }
  &.error {
    border: 1px solid #ff0000 !important;
    background-color: #fff0f0 !important;
  }
  &.success {
    border: 1px solid #00da0f !important;
    background-color: #f0fdf1 !important;
  }
  &.with-tip {
    border-radius: 7px 7px 0 0;
  }
}
.money-error-tip {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
  font-size: 10px;
  font-weight: 500;
  color: #ff0000;
  line-height: 1;

  .error-icon {
    width: 13px;
    height: 13px;
    flex-shrink: 0;
    object-fit: contain;
  }
}
.money-limit-tip {
  min-height: 33px;
  height: auto;
  padding: 2px 6px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
  gap: 0 2px;
  row-gap: 0;
  border-radius: 0 0 7px 7px;
  background-color: #fdf6e9;
  border: 1px solid #f0d9a8;
  border-top: none;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 11px;
  color: #006cff;
  text-align: left;
  line-height: 1.2;

  .tip-num {
    text-decoration: underline;
    text-underline-offset: 1px;

    &.tip-num-bonus {
      font-weight: 700;
      color: #f9d115;
    }
  }
  .textColorGreen {
    color: #00da0f;
  }
}
.field-border-b {
  border-radius: 7px 7px 0 0;
  border: 1px solid var(--deposito-card-border-bottom);
}
.field-border-t {
  padding: 7px 10px;
  border-radius: 0 0 7px 7px;
  background-color: #f5eceb;
  border-bottom: 1px solid #f0bab5;
  border-left: 1px solid #f0bab5;
  border-right: 1px solid #f0bab5;
  height: 44px;
  line-height: 15px;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 11px;
  color: #000000;
  text-align: left;
  font-style: normal;
  text-transform: none;
  .t-all {
    font-weight: 600;
    margin-left: 2px;
  }
  .t-coletar {
    color: #04be02;
  }
  .t-add {
    color: #ffaa09;
  }
}
.deposit-container {
  width: 356px;
  min-height: 100px;
  background: var(--special-deposito-bonus-bg);
  border-radius: 10px 10px 10px 10px;
  border: 1px solid var(--special-deposito-bonus-border);
  margin: 0 10px;
  .gife-icon {
    width: 19px;
    height: 19px;
    margin-right: 5px;
    margin-left: 22px;
  }

  .oferta {
    font-family: Roboto, Roboto;
    font-weight: 600;
    font-size: 12px;
    color: var(--special-deposito-bonus-header-label);
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .deposit-desc {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 10px;
    color: var(--special-deposito-bonus-header-value);
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin: 10px 0;
  }

  .lt-view {
    position: relative;
    // border: 1px solid red;
    height: 14px;
    margin-right: 5px;
    padding-right: 3px;
    --van-count-down-font-size: 10px;
    --van-count-down-text-color: var(--special-deposito-bonus-header-tag-text);
    border: 1px solid var(--van-count-down-text-color);
    .lt-icon-container {
      position: relative;
      margin-left: -10px;

      .lt-icon {
        width: 22px;
        height: 14px;
        margin-right: 2px;
      }
      .lt-text {
        position: absolute;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
        color: white;
        font-size: 9px;
      }
    }
  }

  .primeiro {
    width: 344px;
    height: 32px;
    background: var(--special-deposito-bonus-list-item-bg);
    border-radius: 5px 5px 5px 5px;
    margin: 0 6px;
    margin-bottom: 5px;

    .primeiro-1 {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      background-color: var(--special-deposito-bonus-list-border);
      height: 32px;
      width: 5px;
    }
    .primeiro-2-img {
      width: 22px;
      height: 22px;
      margin-left: 10px;
    }

    .primeiro-3-text {
      width: 28px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 10px;
      color: var(--special-deposito-bonus-list-left-label);
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-left: 8px;
    }
    .primeiro-4-text {
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 10px;
      color: var(--special-deposito-bonus-list-left-value);
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-left: 5px;
    }
    .primeiro-5-text {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      height: auto;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 10px;

      text-align: right;
      font-style: normal;
      text-transform: none;

      .label {
        color: var(--special-deposito-bonus-list-right-label);
      }
      .value {
        color: var(--special-deposito-bonus-list-right-value);
      }
    }
    .primeiro-6-img {
      width: 10px;
      height: 8px;
      margin: 0 10px;
    }
  }
}

.expand-container {
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 12px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.expand-text {
  margin-right: 5px;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 12px;
  color: var(--special-deposito-bonus-footer-more-text);
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.expand-icon {
  margin-top: 2px;
  font-size: 12px;
  color: var(--special-deposito-bonus-footer-arrow-icon);
}

.tip-container {
  margin: 10px;
  font-family: Roboto, Roboto;
  word-break: break-all;
  font-size: 12px;
  color: var(--deposito-card-tip-text);
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.deposit-now-button {
  margin: 15px 10px;
  width: 354px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  background: var(--deposito-card-button-bg);
  border-radius: 5px;
  font-size: 12px;
  color: var(--deposito-card-button-text);
  cursor: pointer;
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
    background: #999;
    color: #f5f5f5;
  }
}

.money-view {
  min-width: 70px;
  height: 20px;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid var(--special-deposito-balance-border);

  .money {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 12px;
    color: var(--special-deposito-balance-text);
    text-align: center;
    font-style: normal;
    text-decoration-line: underline;
    text-underline-offset: 2px;
    text-transform: none;
  }
}

.refresh-icon {
  // width: 15px;
  // height: 15px;
  margin-right: 2px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.refresh-icon.rotating {
  animation: rotateThreeTimes 1s linear forwards;
}

@keyframes rotateThreeTimes {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(1080deg); /* 3圈 = 3 * 360度 */
  }
}

.pagamento-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 10px;
  background-color: var(--deposito-view-bg);
  z-index: 99;
}

.pagamento-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.saldo-label {
  font-size: 13px;
  font-weight: 400;
  color: var(--deposito-card-title);
  white-space: nowrap;
}

.pagamento {
  font-family: Roboto, Roboto;
  font-weight: bold;
  font-size: 13px;
  color: var(--deposito-card-title);
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.support-icon {
  width: 17px;
  height: 15px;
  margin-right: 8px;
}
.message-icon {
  width: 15px;
  height: 15px;
}
.line1 {
  width: 355px;
  height: 1px;
  background: var(--deposito-card-border-bottom);
  margin-top: 10px;
}
.line2 {
  width: 355px;
  height: 1px;
  background: var(--deposito-card-border-bottom);
  margin-top: 10px;
}

.deposito {
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 12px;
  color: var(--deposito-card-title);
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.dep-item-check {
  width: 81px;
  height: 40px;
  background: var(--deposito-amount-item-bg);
  border-radius: 4px;
  border: 1px solid var(--deposito-amount-item-active-border);

  .dep-t {
    height: 22px;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 12px;
    color: var(--deposito-amount-item-active-value);
  }
  .dep-t2 {
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 12px;
    color: var(--deposito-amount-item-value);
  }
  .dep-b {
    height: 17px;
    background-color: rgba(255, 170, 9, 0.1);
    width: 100%;
    border-radius: 0 0 4px 4px;
    color: var(--deposito-amount-item-value__highlight);
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 12px;
  }
}

.dep-group-container {
  display: grid;
  grid-template-columns: repeat(4, calc(100% / 4 - 3 * 10px / 4));
  grid-gap: 10px;
  margin-top: 10px;
}
.dep-item {
  width: 100%;
  height: 40px;
  // background: var(--deposito-amount-item-bg);
  border-radius: 4px;
  border: 1px solid var(--deposito-amount-item-border);

  .dep-t {
    height: 22px;
    font-family: Roboto, Roboto;
    font-weight: 600;
    font-size: 12px;
    color: var(--deposito-card-title); //var(--deposito-amount-item-value);
  }
  .dep-t2 {
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 12px;
    color: var(--deposito-amount-item-value);
  }
  .dep-b {
    height: 17px;
    background-color: rgba(255, 170, 9, 0.1);
    width: 100%;
    border-radius: 0 0 4px 4px;
    color: var(--deposito-amount-item-value__highlight);
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 12px;
  }
}
.lembrete {
  width: 355px;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 12px;
  color: var(--deposito-card-value);
  text-align: left;
  font-style: normal;
  text-transform: none;
  line-height: 15px;
}
.pt-icon {
  width: 17px;
  height: 17px;
  margin-left: 1px;
}

// 此处可以全局样式 省的重复
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  z-index: 9990;
  overflow: hidden;
}
</style>
